import { useLocation } from "react-router-dom";
import { useIsMobile } from "../../../utils/Functions";

export const useIsHomePage = () => {
  const location = useLocation();
  const isMobile = useIsMobile();
  // It returns true only if the path is "/home" AND the device is not mobile.
  return location.pathname === "/home" && !isMobile;
};
